<template>
  <main class="flex-item" v-if="renewal.rnw01p !== undefined && renewal.hsm03p !== undefined && renewal.rnw02p !== undefined">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">fact_check</span>更新内容確認</p>
      </header>

      <!-- 目的の所在地 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">home</span>目的の所在地</div>
          </header>
          <div class="card-content">
            <div class="columns ml-5">
              <div class="column py-1">
                <p>住所</p>
              </div>
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka1" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1" />
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka2" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1">
                <p>住所（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka3" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1" />
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka4" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 申込人（契約者）情報 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">person</span>申込人（契約者）情報</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <p class="mb-0">氏名</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekykj" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">氏名（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekykn" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">郵便番号</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekyyn" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">住所</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya1" />
              </div>
            </div>
            <div class="columns">
              <div class="column" />
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya2" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">住所（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya3" />
              </div>
            </div>
            <div class="columns">
              <div class="column" />
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya4" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">携帯電話番号</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekyt2" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">その他電話番号</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekytl" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">メールアドレス</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekyma" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 被保険者 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">groups</span>被保険者</div>
          </header>
          <div class="card-content">
            <!-- 目的の所有者の代表者(undefindになることはないが一応) -->
            <div class="card block" v-if="mainInsured !== undefined">
              <input
                type="checkbox"
                id="owner-same-contractor"
                class="check-type-2 is-cb-medium"
                :true-value="constants.HAIIIE.HAI"
                :false-value="constants.HAIIIE.IIE"
                v-model="mainInsured.tf_rhkysm"
                disabled
              />
              <header class="card-header">
                <div class="is-size-4 card-header-title">
                  <span class="material-icons accent-color">account_circle</span>目的の所有者の代表者
                  <label for="owner-same-contractor" class="is-size-6 ml-6 has-text-weight-bold has-text-dark">申込人と同じ</label>
                </div>
              </header>
              <div class="card-content">
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">氏名</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhksj" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">氏名（フリガナ）</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhksk" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">生年月日</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhkbt" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">性別</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="getGenderText(mainInsured.tf_rhhksx)" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">携帯電話番号</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhkt2" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">その他電話番号</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhktl" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">メールアドレス</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhkma" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 被保険者 -->
            <template v-if="subInsureds !== undefined">
              <SubInsured
                v-for="(v, i) in subInsureds"
                :key="i"
                :tf_khhkno="v.tf_rhhkno"
                :tf_khhksj="v.tf_rhhksj"
                :tf_khhksk="v.tf_rhhksk"
                :tf_khhkbt="v.tf_rhhkbt"
                :tf_khhksx="v.tf_rhhksx"
              />
            </template>
          </div>
        </div>
      </div>

      <!-- 申込内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">article</span>申込内容</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <p class="mb-0">申込日</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="nowDate" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">保険期間</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="`${renewal.rnw01p.tf_reskdt} ~ ${renewal.rnw01p.tf_remkdt}`" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">契約区分</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">新規</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">建物</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getKozoText(mainInsured?.tf_rhkozo ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">物件</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getSyoyuText(mainInsured?.tf_rhsykb ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">目的</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getYoutoText(mainInsured?.tf_rhytkb ?? "") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 補償内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">savings</span>補償内容</div>
          </header>
          <div class="card-content">
            <div class="is-size-5 block">合計保険料</div>
            <div class="columns ml-2">
              <div class="column py-1">
                <p>合計金額</p>
              </div>
              <div class="column has-text-weight-bold is-flex-grow-2 py-1">
                <p class="is-size-5">{{ commaSplit(selectedPlan?.tf_hrhrgk ?? 0) }}円</p>
              </div>
            </div>

            <div class="is-size-5 block">家財保険</div>
            <div class="columns ml-2">
              <div class="column py-1">
                <p>保険金額</p>
              </div>
              <div class="column has-text-weight-bold is-flex-grow-2 py-1">
                <p>{{ commaSplit(selectedPlan?.tf_hrhkkg ?? 0) }}万円</p>
              </div>
            </div>
            <div class="columns ml-2">
              <div class="column py-1">
                <p>保険料</p>
              </div>
              <div class="column has-text-weight-bold is-flex-grow-2 py-1">
                <p>{{ commaSplit(selectedPlan?.tf_hrhrhk ?? 0) }}円</p>
              </div>
            </div>

            <div class="is-size-5 block">賠償責任保険</div>
            <div class="columns ml-2">
              <div class="column py-1">
                <p>保険金額</p>
              </div>
              <div class="column has-text-weight-bold is-flex-grow-2 py-1">
                <p>{{ commaSplit(selectedPlan?.tf_hrhtkg ?? 0) }}万円</p>
              </div>
            </div>
            <div class="columns ml-2">
              <div class="column py-1">
                <p>保険料</p>
              </div>
              <div class="column has-text-weight-bold is-flex-grow-2 py-1">
                <p>{{ commaSplit(selectedPlan?.tf_hrhthk ?? 0) }}円</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- お支払い方法 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">update</span>お支払い方法</div>
          </header>
          <div class="card-content">
            <div class="columns py-4">
              <div class="column">
                <p>選択したお支払い方法</p>
              </div>
              <div class="column is-flex-grow-2">
                <span class="is-size-5"><strong>コンビニ決済</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- その他保険 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header card-title">
            <p class="card-header-title is-size-4"><span class="material-icons accent-color">more</span>その他保険</p>
          </header>
          <div class="card-content other-insurance-info">
            <div class="other-insured-item">
              <input
                type="checkbox"
                id="other-insured-join"
                class="check-type-1"
                v-model="renewal.rnw01p.tf_rethum"
                :true-value="constants.UMU.ARI"
                :false-value="constants.UMU.NASI"
                disabled
              />
              <label for="other-insured-join" class="has-text-weight-bold has-text-dark">他社の保険に加入している</label>
              <div class="other-insured-join-info checked-info">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="field">
                      <div class="control">
                        <input
                          type="checkbox"
                          v-model="thRethsrArr"
                          :value="constants.HOKEN_SYURUI.HOUSE"
                          id="other-insured-household"
                          class="check-type-1"
                          disabled
                        />
                        <label for="other-insured-household" class="has-text-dark mr-6">家財保険</label>
                        <input
                          type="checkbox"
                          v-model="thRethsrArr"
                          :value="constants.HOKEN_SYURUI.LIABILITY"
                          id="other-insured-liability"
                          class="check-type-1"
                          disabled
                        />
                        <label for="other-insured-liability" class="has-text-dark">個人賠償責任保険</label>
                      </div>
                    </div>
                  </div>
                  <div class="column is-12">
                    <label class="label">会社名</label>
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" :value="renewal.rnw01p.tf_rethcm" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="card-footer">
        <div class="card-footer-item">
          <span class="mr-4">
            <router-link :to="{ name: 'Payment' }" class="card-footer-item button is-primary is-normal is-medium">決済画面へ進む</router-link>
          </span>
          <span>
            <router-link :to="{ name: 'Renewal' }" class="card-footer-item button is-normal is-medium">更新内容の入力に戻る</router-link>
          </span>
        </div>
      </footer>
    </div>
  </main>
</template>

<script lang="ts">
import { getRenewal, renewalResponse, rnw02p, hsm03p } from "@/api/renewal";
import router from "@/router";
import { useStore } from "@/store";
import axios from "axios";
import { commaSplit } from "common/src/utils/number";
import { getGenderText, getHaraikomiText } from "common/src/utils/codes";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import SubInsured from "common/src/components/SubInsured.vue";
import constants from "common/src/constants";
import { defineComponent, reactive, ref, Ref, UnwrapRef } from "vue";
import { getSyoyuText, getYoutoText, getKozoText } from "common/src/utils/codes";

export default defineComponent({
  components: {
    HyphenParagraph,
    SubInsured,
  },
  setup() {
    const store = useStore();

    const renewal: UnwrapRef<renewalResponse> = reactive({
      rnw01p: undefined,
      hsm03p: undefined,
      rnw02p: undefined,
    });
    const mainInsured: Ref<rnw02p | undefined> = ref(undefined);
    const subInsureds: Ref<rnw02p[] | undefined> = ref(undefined);
    // 他保険種類管理配列
    const thRethsrArr: Ref<string[]> = ref([]);

    const selectedPlan: Ref<hsm03p | undefined> = ref(undefined);
    const nowDate = `${new Date().getFullYear()}/${`00${new Date().getMonth() + 1}`.slice(-2)}/${`00${new Date().getDate()}`.slice(-2)}`;

    getRenewal()
      .then((res) => {
        if (res.data.rnw01p?.tf_rekzis === constants.KEIZOKU_ISHI.ARI) {
          router.push({ name: "404" });
          return;
        }

        renewal.rnw01p = res.data.rnw01p;
        renewal.hsm03p = res.data.hsm03p;
        renewal.rnw02p = res.data.rnw02p;

        mainInsured.value = res.data.rnw02p?.find((i) => i.tf_rhhkno === constants.MAIN_INSURED_NUMBER);
        subInsureds.value = res.data.rnw02p
          ?.filter((i) => i.tf_rhhkno !== constants.MAIN_INSURED_NUMBER)
          .sort((a, b) => Number.parseInt(a.tf_rhhkno) - Number.parseInt(b.tf_rhhkno));

        // 更新契約手続きAPI呼び出し用Formの値をセット
        if (renewal.rnw01p !== undefined) {
          renewal.rnw01p.tf_rekytl = store.state.renewal?.rnw01p.tfRekytl ?? "";
          renewal.rnw01p.tf_rekyt2 = store.state.renewal?.rnw01p.tfRekyt2 ?? "";
          renewal.rnw01p.tf_rehscd = store.state.renewal?.rnw01p.tfRehscd ?? "";
          renewal.rnw01p.tf_rehkpl = store.state.renewal?.rnw01p.tfRehkpl ?? "";
          renewal.rnw01p.tf_regkhk = store.state.renewal?.rnw01p.tfRegkhk ?? 0;
          renewal.rnw01p.tf_rehkhh = store.state.renewal?.rnw01p.tfRehkhh ?? "";
          renewal.rnw01p.tf_rethum = store.state.renewal?.rnw01p.tfRethum ?? "";
          renewal.rnw01p.tf_rethcm = store.state.renewal?.rnw01p.tfRethcm ?? "";
          thRethsrArr.value.push(...(store.state.renewal?.rnw01p.tfRethsr?.split("/") ?? ""));
          if (store.state.renewal?.security.tfHnuuid && store.state.mail) {
            renewal.rnw01p.tf_rekyma = store.state.mail;
          }
          selectedPlan.value = res.data.hsm03p?.find((i) => i.tf_hrplan === store.state.renewal?.rnw01p.tfRehkpl);
        }
        if (mainInsured?.value !== undefined) {
          mainInsured.value.tf_rhhktl = store.state.renewal?.rnw02p.tfRhhktl ?? "";
          mainInsured.value.tf_rhhkt2 = store.state.renewal?.rnw02p.tfRhhkt2 ?? "";
        }
      })
      .catch((err) => {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      });

    return {
      renewal,
      mainInsured,
      subInsureds,
      thRethsrArr,
      selectedPlan,
      nowDate,
      getGenderText,
      getHaraikomiText,
      commaSplit,
      constants,
      getSyoyuText,
      getYoutoText,
      getKozoText,
    };
  },
});
</script>
